import React, { useState } from 'react';
import AriaOrb from './AriaOrb';

const names = [
  '1 — Constellation Gather',
  '2 — Orbital Rings',
  '3 — Pulse Echo',
  '4 — Breathing Crystal',
  '5 — Aurora Streams',
];

export default function AriaOrbDemo() {
  const [active, setActive] = useState(1);
  const [mode, setMode] = useState('listening'); // idle | listening | speaking

  return (
    <div style={{
      background: '#0f0f12', minHeight: '100vh', display: 'flex',
      flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif', color: '#fff',
    }}>
      <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 6, letterSpacing: 0.5 }}>
        Aria Listening Animations
      </h1>
      <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', marginBottom: 24 }}>
        Click a mode below, then select an animation
      </p>

      {/* Mode toggles */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 28 }}>
        {['idle', 'listening', 'speaking'].map(m => (
          <button key={m} onClick={() => setMode(m)} style={{
            padding: '8px 20px', borderRadius: 20, border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase',
            background: mode === m ? (m === 'listening' ? '#3b82f6' : m === 'speaking' ? '#dc3448' : '#555') : 'rgba(255,255,255,0.08)',
            color: mode === m ? '#fff' : 'rgba(255,255,255,0.5)',
            transition: 'all 0.2s',
          }}>
            {m}
          </button>
        ))}
      </div>

      {/* Big orb */}
      <div style={{ position: 'relative', marginBottom: 20 }}>
        <AriaOrb
          speaking={mode === 'speaking'}
          listening={mode === 'listening'}
          listenAnimation={active}
          size={340}
        />
      </div>

      <p style={{ fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.7)', marginBottom: 24 }}>
        {names[active - 1]}
      </p>

      {/* Thumbnails */}
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
        {[1, 2, 3, 4, 5].map(n => (
          <div key={n} onClick={() => setActive(n)} style={{
            cursor: 'pointer', textAlign: 'center',
            border: active === n ? '2px solid #3b82f6' : '2px solid rgba(255,255,255,0.1)',
            borderRadius: 16, padding: 8, transition: 'all 0.2s',
            background: active === n ? 'rgba(59,130,246,0.08)' : 'transparent',
          }}>
            <AriaOrb
              speaking={false}
              listening={true}
              listenAnimation={n}
              size={120}
            />
            <p style={{
              fontSize: 11, marginTop: 4, color: active === n ? '#3b82f6' : 'rgba(255,255,255,0.4)',
              fontWeight: active === n ? 600 : 400,
            }}>
              {names[n - 1]}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
